import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setCurrentScreen } from '../../store/orderSlice';
import PanarottisIcon from '../../data/PanaImages/PanarottisIcon.png';
import CardPaymentImage from '../../data/PanaImages/CardPayment.png';

const nexaRustStack = '"Nexa Rust Sans Black A", "Museo Sans", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';

const PayHereScreen: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = window.setTimeout(() => {
      dispatch(setCurrentScreen('success'));
    }, 5000);

    return () => window.clearTimeout(timer);
  }, [dispatch]);

  const handleAdvance = () => {
    dispatch(setCurrentScreen('success'));
  };

  return (
    <div
      className="min-h-screen bg-[#f2f1ec] flex flex-col items-center px-10 pt-12 pb-12"
      role="presentation"
      onClick={handleAdvance}
    >
      <img
        src={PanarottisIcon}
        alt="Panarottis"
        className="w-[100px] h-[75.76px] object-contain"
      />

      <h1
        className="mt-12 text-center uppercase text-[#185C53]"
        style={{
          fontFamily: nexaRustStack,
          fontSize: '80px',
          lineHeight: '88px',
          fontWeight: 900,
          letterSpacing: '2px',
        }}
      >
        Insert or Tap Your Card
      </h1>

      <img
        src={CardPaymentImage}
        alt="Insert or tap card"
        className="mt-20 w-[420px] h-[465.16px] object-contain"
      />
    </div>
  );
};

export default PayHereScreen;

